var _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDepthOverviewMiniAppAsRectangle2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 98,
    viewBox: "0 0 185 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 185,
    height: 98,
    rx: 5,
    fill: "#94618F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepthOverviewMiniAppAsRectangle2);
export default __webpack_public_path__ + "static/media/depth_overview_mini_app_as_rectangle2.42de5a20aa725bbd43f7b3f67a531849.svg";
export { ForwardRef as ReactComponent };